import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Sticky from 'react-stickynode';
import { ButtonV2 } from '@zola/zola-ui';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import '../../../stylesheets/components/ThemesFilterPanel.less';

class ThemesFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedColorKeys: [],
    };
    this.removeFilter = this.removeFilter.bind(this);
    this.filterByColor = this.filterByColor.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedColorKeys.length !== this.state.selectedColorKeys.length) {
      const options = Object.assign(
        {},
        {
          selectedColorKeys: this.state.selectedColorKeys,
        }
      );
      this.props.onFilterChange(options);
    }
  }

  isColorSelected(color) {
    const { selectedColorKeys } = this.props;
    return selectedColorKeys.indexOf(color) > -1;
  }

  filterByColor(color) {
    if (this.isColorSelected(color.key)) {
      this.removeFilter(color.key);
      return;
    }
    const { selectedColorKeys } = this.state;
    this.setState({
      selectedColorKeys: selectedColorKeys.concat([color.key]),
    });
  }

  resetThemes() {
    const { onResetThemes } = this.props;
    const { selectedColorKeys } = this.state;
    this.setState({
      selectedColorKeys: [],
    });
    onResetThemes(selectedColorKeys);
  }

  removeFilter(color) {
    const { selectedColorKeys: tempSCK } = this.state;
    const selectedColorKeys = tempSCK.slice();
    const index = selectedColorKeys.indexOf(color);

    selectedColorKeys.splice(index, 1);
    this.setState({ selectedColorKeys });
    const options = Object.assign(
      {},
      {
        selectedColorKeys,
      }
    );
    this.props.onFilterChange(options);
  }

  render() {
    const { userContext, colorOptions, resultCount, selectedColorKeys } = this.props;
    const colorPicker = [];
    colorOptions.forEach(color => {
      colorPicker.push(
        <li
          className={['color-filter', this.isColorSelected(color.key) ? 'active' : null].join(' ')}
          key={color.key}
        >
          <div className="with-tooltip no-tooltip-on-mobile" data-tooltip={color.color_name}>
            <span
              className={color.key}
              onClick={() => {
                this.filterByColor(color);
              }}
            />
          </div>
        </li>
      );
    });

    return (
      <div className="theme-filtering-container">
        {/* desktop */}
        <div className="col-md-2" style={{ paddingLeft: '0' }}>
          {((userContext.has_registry && userContext.has_wedding_account) ||
            userContext.has_wedding_account) && (
            <div>
              <Sticky top={120} bottomBoundary=".scroll-container" enableTransforms={false}>
                <div className="desktop-filter-container visible-md visible-lg">
                  <div className="color-panel">
                    <div>
                      <div className="color-panel-heading">
                        <h5 className="serif-text">COLOR</h5>
                      </div>
                      <ul className="color-picker">{colorPicker}</ul>
                      {selectedColorKeys.length > 0 ? (
                        <div className="filter-btn-container">
                          <ButtonV2
                            variant="secondary"
                            className="theme-action clear-all-btn color-panel-clear"
                            onClick={() => {
                              this.resetThemes(selectedColorKeys);
                            }}
                          >
                            Clear All Filters
                          </ButtonV2>
                        </div>
                      ) : null}
                    </div>
                    {window.zola.env !== 'production' && (
                      <div className="listing-sidebar-section features-filter">
                        <h6 className="sidebar-section-header">Special Features</h6>
                        <div className="checkbox checkbox-square">
                          <label htmlFor="has_matching_invitation">
                            <input
                              type="checkbox"
                              name="has_matching_invitation"
                              value=""
                              id="has_matching_invitation"
                            />
                            <span className="input-override">
                              <i className="zolaicon zolaicon-checkmark" />
                            </span>
                            Matching Invitations
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Sticky>
            </div>
          )}
          {(userContext.is_guest ||
            (userContext.has_registry && !userContext.has_wedding_account) ||
            (userContext.registry_ids.length <= 0 && !userContext.has_wedding_account)) && (
            <div>
              <Sticky top={110} bottomBoundary=".scroll-container" enableTransforms={false}>
                <div className="desktop-filter-container visible-md visible-lg">
                  <div className="color-panel sticky-preauth">
                    <div>
                      <div className="color-panel-heading">
                        <h5 className="serif-text">COLOR</h5>
                      </div>
                      <ul className="color-picker">{colorPicker}</ul>
                      {selectedColorKeys.length > 0 ? (
                        <div className="filter-btn-container">
                          <ButtonV2
                            variant="secondary"
                            className="theme-action clear-all-btn color-panel-clear"
                            onClick={() => {
                              this.resetThemes(selectedColorKeys);
                            }}
                          >
                            Clear All Filters
                          </ButtonV2>
                        </div>
                      ) : null}
                    </div>
                    {window.zola.env !== 'production' && (
                      <div className="listing-sidebar-section features-filter">
                        <h6 className="sidebar-section-header">Special Features</h6>
                        <div className="checkbox checkbox-square ">
                          <label htmlFor="has_matching_invitation">
                            <input
                              type="checkbox"
                              name="has_matching_invitation"
                              value=""
                              id="has_matching_invitation"
                            />
                            <span className="input-override">
                              <i className="zolaicon zolaicon-checkmark" />
                            </span>
                            Matching Invitations
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Sticky>
            </div>
          )}
        </div>
        {!resultCount && (
          <div className="no-result hidden-xs hidden-sm col-md-9 col-offset-1">
            <h1 className="text-sans">No Results</h1>
            <p className="no-results-copy">
              Select fewer filters to help us find your perfect design.
            </p>
            <div className="results-laptop" />
            <ButtonV2
              variant="secondary"
              className="theme-action clear-all-btn no-results-clear"
              onClick={this.resetThemes}
            >
              Clear All Filters
            </ButtonV2>
          </div>
        )}
        {/* mobile */}
        <div className="mobile-filter-container visible-xs visible-sm col-xs-12">
          <Dropdown>
            <DropdownTrigger className="btn btn-dropdown filter-btn">
              <span>FILTER</span>
              <i className="zolaicon zolaicon-chevron-down" />
            </DropdownTrigger>
            <DropdownContent>
              <div className="filter-dropdown-menu dropdown-menu dropdown-menu-left">
                <div className="desktop-filter-container">
                  <div className="color-panel">
                    <div className="color-panel-heading">
                      <h5 className="sans-text">COLOR</h5>
                    </div>
                    <ul className="color-picker">{colorPicker}</ul>
                    {this.state.selectedColorKeys.length !== 0 && (
                      <div className="filter-btn-container text-center">
                        <ButtonV2
                          variant="secondary"
                          className="theme-action clear-all-btn"
                          onClick={() => {
                            this.resetThemes(selectedColorKeys);
                          }}
                        >
                          Clear All Filters
                        </ButtonV2>
                      </div>
                    )}
                    {window.zola.env !== 'production' && (
                      <div className="listing-sidebar-section features-filter">
                        <h6 className="sidebar-section-header">Special Features</h6>
                        <div className="checkbox checkbox-square ">
                          <label htmlFor="has_matching_invitation">
                            <input
                              type="checkbox"
                              name="has_matching_invitation"
                              value=""
                              id="has_matching_invitation"
                            />
                            <span className="input-override">
                              <i className="zolaicon zolaicon-checkmark" />
                            </span>
                            Matching Invitations
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {!resultCount && (
                <div className="no-result visible-xs visible-sm col-md-9">
                  <h1 className="text-sans">No Results</h1>
                  <p className="no-results-copy">
                    Select fewer filters to help us find your perfect design.
                  </p>
                  <div className="results-laptop" />
                  <ButtonV2
                    variant="secondary"
                    className="theme-action clear-all-btn"
                    onClick={() => this.resetThemes()}
                  >
                    Clear All Filters
                  </ButtonV2>
                </div>
              )}
            </DropdownContent>
          </Dropdown>
        </div>
      </div>
    );
  }
}

ThemesFilter.propTypes = {
  selectedColorKeys: PropTypes.arrayOf(PropTypes.string),
  colorOptions: PropTypes.arrayOf(PropTypes.shape({})),
  resultCount: PropTypes.number,
  onFilterChange: PropTypes.func.isRequired,
  userContext: PropTypes.shape({}),
  onResetThemes: PropTypes.func,
};

const mapStateToProps = state => ({
  colorOptions: state.website.themeListing.color_options,
  selectedColorKeys: state.website.themeListing.selected_color_keys,
  resultCount: state.website.themeListing.result_count,
  userContext: state.user.userContext,
});

export default connect(mapStateToProps)(ThemesFilter);



// WEBPACK FOOTER //
// ./src/components/manage/website/ThemesFilter.jsx